import { useEffect, useState } from 'react'

import { useAsyncTable } from '../../../Table'
import {
  DOC_FLOW_SENDING_HEADER_PROPS,
  getSendingTableApiUrls,
  isDocFlowSendingWidgetTypeCommunicationSettings,
} from '../../DocFlowSending'
import { useDocFlowContext } from '../useDocFlowContext'

import { getSendingWidgetContent } from './useSendingPhase.utils'

export function useSendingPhase({ activeWidget, getFileProcess }) {
  const { documentId, setFooterProps } = useDocFlowContext()

  const [isPageLoader, setPageLoader] = useState(false)

  const [emailBlackList, setEmailBlackList] = useState(null)

  const tableData = useAsyncTable({
    ...getSendingTableApiUrls(documentId),
    withoutSubMenu: true,
  })

  const { handleLoadInit } = tableData

  useEffect(() => {
    if (isDocFlowSendingWidgetTypeCommunicationSettings(activeWidget)) {
      handleLoadInit()
    }
  }, [activeWidget])

  useEffect(() => {
    setFooterProps({
      ...DOC_FLOW_SENDING_HEADER_PROPS,
      onReloadProcess: getFileProcess,
    })
  }, [])

  const sendingWidgetContent = getSendingWidgetContent(activeWidget)

  return {
    emailBlackList,
    isPageLoader,
    sendingWidgetContent,
    setEmailBlackList,
    setPageLoader,
    tableData,
  }
}
